import React, { FC } from 'react'

import { IconLoanProps } from './IconLoan.types'
import * as Styled from './styles/IconLoan.style'

import { nonThemeableRules } from '../../ruleSet'

const IconLoan: FC<IconLoanProps> = ({
  size = nonThemeableRules.defaultSize as number as IconLoanProps['size'],
  isResponsive = false,
}: IconLoanProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M8.967 4.978A4.03 4.03 0 0 0 4.937 9v2.095h7.41m5.593 31.778h20a5 5 0 0 0 5-5v-.905H22.885v.905a5 5 0 0 1-4.945 5v0Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M8.967 4.978A4.03 4.03 0 0 1 13 9v28.878a4.945 4.945 0 1 0 9.887 0v-.655a.25.25 0 0 1 .25-.25H35v-32l-26.032.005Z'
          stroke='#0D0D0D'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M29.872 15.005H17.878m11.994 4.003H17.878m11.994 4.002H17.878'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconLoan
